import dayjs from "dayjs";  
import styles from "../Audit.module.css";
import React, {useCallback, useContext, useEffect, useState} from "react";
import {IAM_SERVER_AUDIT_ADMIN} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import Loading from "../../../utils/loading/Loading";
import {AuditDetailModal, AuditDetailType} from "../modal/AuditDetailModal";
import DetailModal from "../../../utils/modal/DetailModal";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import { TableContext, TableStateType } from "../../../utils/contextapi/TableProvider";
import { useServiceList } from "../../../utils/service/serviceList";
import AuditTable from "../component/AuditTable";

/**
 * 관리자 로그 탭 화면
 * @param props isMobile, searchModel
 */
export const AuditContainer = ({isMobile}) => {
    const {openModal} = useContext(ModalContext);
    const [loading, setLoading] = useState(false);
    const context = useContext(TableContext);
    const [isMobileWindow, setIsMobileWindow] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    //테이블 데이터
    const [cellData, setCellData] = useState([]);
    const [page, setPage] = useState(0);
    const listSize = 10; // 한 페이지당 보여줄 항목 수
    const [totalCount, setTotalCount] = useState(0);

    const {serviceList} = useServiceList();
    const [selectedServiceId, setSelectedServiceId] = useState('');

    const [sortModel, setSortModel] = useState({    
        field: "createdDate",   // 현재 정렬 기준값
        sort: "desc",   // (asc: 오름차순, desc: 내림차순)
    });
    // 데이터 테이블 조회 API
    const fetchData = useCallback(async () => {
        if (!selectedServiceId) {
            setCellData([]);
            setTotalCount(0);
            return;
        }
        setLoading(true);
        try {
            const [start, end] = context.state.dateRange;

            // 필수 조건: 날짜 범위 조건
            const conditions = [
                { field: "serviceId", operator: "EQUALS", value: selectedServiceId },
                { field: "mainType", operator: "NOT_EQUALS", value: "IAM0700" }
            ];

            if (start) {
                const startDate = dayjs(start).startOf('day').valueOf();
                conditions.push({ field: "createdDate", operator: "GREATER_THAN_OR_EQUAL", value: startDate });
            }
            
            // end가 null이 아니거나 유효한 날짜일 때만 endDate 조건 추가
            if (end) { 
                const endDate = dayjs(end).endOf('day').valueOf();
                conditions.push({ field: "createdDate", operator: "LESS_THAN_OR_EQUAL", value: endDate });
            }

            // 선택 조건: 검색 조건 있을 때만 추가
            if (context.state.selectedMain.trim()) {
                conditions.push({ field: "mainType", operator: "EQUALS", value: context.state.selectedMain });
            }
            if (context.state.selectedSub.trim()) {
                conditions.push({ field: "subType", operator: "EQUALS", value: context.state.selectedSub });
            }

            const params = {
                page: page,
                size: listSize,
                sortField: [sortModel.field],
                sortOrder: [sortModel.sort],
                operator: "AND",
                conditions
            };

            const res = await axios.post(`${IAM_SERVER_AUDIT_ADMIN}/all`, params);
            const { data, recordsTotal } = res.data.data;
            setTotalCount(recordsTotal);
            setCellData(data);

        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [page, selectedServiceId, context.state.dateRange, context.state.selectedMain, context.state.selectedSub, sortModel]);


    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        setPage(0);
    }, [selectedServiceId, context.state.dateRange, context.state.selectedMain, context.state.selectedSub]);
 

    const handleNextPage = () => {
        setPage((prevPage) => {
            const newPage = prevPage + 1;
            return newPage;
        });
    };

    const handlePrevPage = () => {
        setPage((prevPage) => {
            const newPage = Math.max(prevPage - 1, 0);
            return newPage;
        });
    };

    const handleDetail = (row) => {


        
        const modalContent = <AuditDetailModal type={AuditDetailType.ADMIN} modalData={row} />
        const modalOption = {modalTitle: '상세 정보'}
        openModal(<DetailModal content={modalContent} option={modalOption} /> );
    }

    return (
        <>
            {loading ? <Loading/> :
                <AuditTable
                    datas={cellData}
                    context={context}
                    detailAudit={handleDetail}
                    onPrevPage={handlePrevPage}
                    onNextPage={handleNextPage}
                    disablePrev={page === 0}
                    disableNext={(page + 1) * listSize >= totalCount}
                    pageNumber={page}
                    totalCount={totalCount}
                    listSize={listSize}
                    isMobileWindow={isMobileWindow}
                    serviceList={serviceList}
                    selectedServiceId={selectedServiceId}
                    onServiceChange={(e) => setSelectedServiceId(e.target.value)}
                    selectedMainCode={context.state.selectedMain}
                    onMainCodeChange={(e) => context.actions.contextDispatch({type: TableStateType.SELECTED_MAIN, data: e.target.value})}
                    selectedSubCode={context.state.selectedSub}
                    onSubCodeChange={(e) => context.actions.contextDispatch({type: TableStateType.SELECTED_SUB, data: e.target.value})}
                    sortModel={sortModel}
                    onSortChange={setSortModel}
                />
            }
        </>
    )
}